export const MEMBERSHIP_CONCERN_CREATE = 'MEMBERSHIP_CONCERN_CREATE';
export const MEMBERSHIP_CONCERN_CREATE_INIT = 'MEMBERSHIP_CONCERN_CREATE_INIT';

export const MEMBERSHIP_CONCERN_UPDATE = 'MEMBERSHIP_CONCERN_UPDATE';
export const MEMBERSHIP_CONCERN_UPDATE_INIT = 'MEMBERSHIP_CONCERN_UPDATE_INIT';

export const MEMBERSHIP_CONCERN_DELETE = 'MEMBERSHIP_CONCERN_DELETE';
export const MEMBERSHIP_CONCERN_DELETE_INIT = 'MEMBERSHIP_CONCERN_DELETE_INIT';
